import { render, staticRenderFns } from "./DialogConfirmEmail.pug?vue&type=template&id=5c4b909c&lang=pug&"
import script from "./DialogConfirmEmail.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports